import * as ko from 'knockout'
import { ObservableFinisher } from '@classic/Betting-v2/Model/Observables/ObservableFinisher'
import finisherPriceTemplate from './finisher.prices.tpl.html'
import fieldFinisherPriceTemplate from './field.finisher.prices.tpl.html'
import { FieldFinisherPricesViewModel } from './FieldFinisherPricesViewModel'
import { FinisherPricesViewModel } from './FinisherPricesViewModel'

if (!ko.components.isRegistered('finisher-prices')) {
  ko.components.register('finisher-prices', {
    viewModel: {
      createViewModel: (params: { finisher: ObservableFinisher }) => {
        const viewModel = new FinisherPricesViewModel(params)
        return viewModel
      },
    },
    template: finisherPriceTemplate,
  })
}

if (!ko.components.isRegistered('field-finisher-prices')) {
  ko.components.register('field-finisher-prices', {
    viewModel: {
      createViewModel: (params: { finisher: ObservableFinisher }) => {
        const viewModel = new FieldFinisherPricesViewModel(params)
        return viewModel
      },
    },
    template: fieldFinisherPriceTemplate,
  })
}
